import type { AriaRole, ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import { type BannerVariants, bannerVariants } from './banner-variants';

type BannerProps = BannerVariants & {
  title?: ReactNode;
  children?: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
  role?: AriaRole;
  id?: string;
  className?: string;
};

export function Banner({
  tone,
  size,
  title,
  children,
  icon,
  action,
  role,
  id,
  className,
}: BannerProps) {
  return (
    <div data-slot="banner" role={role} className={cn(bannerVariants({ tone, size }), className)}>
      {icon}
      <p id={id} className="shrink grow basis-90">
        {title ? <span className="font-semibold">{title}</span> : null}
        {title && children ? ' ' : null}
        {children}
      </p>
      {action}
    </div>
  );
}
